const backendDomin = process.env.REACT_APP_BACKEND_URL

const SummaryApi = {
    signUP : {
        url : `${backendDomin}/api/signup`,
        method : "post"
    },
    signIn : {
        url : `${backendDomin}/api/signin`,
        method : "post"
    },
    current_user : {
        url : `${backendDomin}/api/user-details`,
        method : "get"
    },
    logout_user : {
        url : `${backendDomin}/api/userLogout`,
        method : 'get'
    },
    allUser : {
        url : `${backendDomin}/api/all-user`,
        method : 'get'
    },
    salesmanAllUsers : {
        url : `${backendDomin}/api/salesmanAllUsers`,
        method : 'get'
    },

    
    updateUser : {
        url : `${backendDomin}/api/update-user`,
        method : "post"
    },
    uploadProduct : {
        url : `${backendDomin}/api/upload-product`,
        method : 'post'
    },

    uploadMultipleProducts: {
        url: `${backendDomin}/api/upload-multiple-products`,
        method: 'POST',
      },
      
    allProduct : {
        url : `${backendDomin}/api/get-product`,
        method : 'get'
    },
    cosmeticProduct : {
        url : `${backendDomin}/api/get-cosmetic-product`,
        method : 'get'
    },
    medicineProduct : {
        url : `${backendDomin}/api/get-medicine-product`,
        method : 'get'
    },
    updateProduct : {
        url : `${backendDomin}/api/update-product`,
        method  : 'post'
    },
    getAllProductsByType : {
        url : `${backendDomin}/api/getAllProductsByType`,
        method : 'POST'
    },
    addProductToOrder : {
        url : `${backendDomin}/api/addProductToOrder`,
        method : 'POST'
    },
    
    
    categoryProduct : {
        url : `${backendDomin}/api/get-categoryProduct`,
        method : 'post'
    },
    categoryWiseProduct : {
        url : `${backendDomin}/api/category-product`,
        method : 'post'
    },
    productDetails : {
        url : `${backendDomin}/api/product-details`,
        method : 'post'
    },
    addToCartProduct : {
        url : `${backendDomin}/api/addtocart`,
        method : 'post'
    },
    addToCartProductCount : {
        url : `${backendDomin}/api/countAddToCartProduct`,
        method : 'get'
    },
    addToCartProductView : {
        url : `${backendDomin}/api/view-card-product`,
        method : 'get'
    },
    updateCartProduct : {
        url : `${backendDomin}/api/update-cart-product`,
        method : 'post'
    },
    deleteCartProduct : {
        url : `${backendDomin}/api/delete-cart-product`,
        method : 'post'
    },
    searchProduct : {
        url : `${backendDomin}/api/search`,
        method : 'get'
    },
    searchCosmeticProduct : {
        url : `${backendDomin}/api/search-cosmetic`,
        method : 'get'
    },
    filterProduct : {
        url : `${backendDomin}/api/filter-product`,
        method : 'post'
    },
    forgotPassword: {
        url: `${backendDomin}/api/forgot-password`,
        method: 'post'
    },
    userOTPVerify: {
        url: `${backendDomin}/api/userOTPVerify`,
        method: 'post',
    },
    ResetPassword: {
        url: `${backendDomin}/api/userResetPassword`,
        method: 'post',
    },
    
    userOrderMail: {
        url: `${backendDomin}/api/userOrderMail`,
        method: 'post',
    },
    clearCartProduct: {
        url: `${backendDomin}/api/clearCartProduct`,
        method: 'post',
    },
    editProfile: {
        url: `${backendDomin}/api/editProfile`,
        method: 'post',
    },
    changePassword: {
        url: `${backendDomin}/api/changePassword`,
        method: 'post',
    },

    updateUserDebt: {
        url: `${backendDomin}/api/updateUserDebt`,
        method: 'post',
    },
    updateProductsQuantity: {
        url: `${backendDomin}/api/updateProductsQuantity`,
        method: 'post',
    },
    getOrder: {
        url: `${backendDomin}/api/order-list`,
        method: 'post',
    },
    
    payment : {
        url : `${backendDomin}/api/checkout`,
        method  : 'post'
    },

    orderCosmeticController : {
        url : `${backendDomin}/api/orderCosmeticController`,
        method : 'post'
    },
    

    allOrder : {
        url : `${backendDomin}/api/all-order`,
        method : 'post'
    },
    deptPaymentController:{
        url : `${backendDomin}/api/deptPaymentController`,
        method : 'post'
    },
    getDeptRequests: {
        url: `${backendDomin}/api/dept-request-list`, 
        method: 'post'
      },
      getDistinctCategories: {
        url: `${backendDomin}/api/getDistinctCategories`, 
        method: 'post'
      },

    adminGetDeptRequests: {
        url: `${backendDomin}/api/admin-view-user-request`, 
        method: 'get'
    },
    adminUpdateRequestStatus:{
        url: `${backendDomin}/api/updateStatus`, 
        method: 'put'
    },

    getUserById:{
        url: `${backendDomin}/api/adminGetuser`, 
        method: 'get'
    },
    

    adminViewUserOrders: {
        url: `${backendDomin}/api/admin-view-user-orders`, 
        method: 'get'
    },
    adminEditUserStatus:{
        url: `${backendDomin}/api/admin-edit-order-status`, 
        method: 'put'
    },

    adminEditAllOrdersStatus:{
        url: `${backendDomin}/api/admin-edit-all-orders-status`, 
        method: 'put'
    },
    adminEditOrderSalesman: {
        url: `${backendDomin}/api/adminEditOrderSalesman`,
        method: 'PUT'
      }
,      
    
    
    adminEditAllUserRequests:{
        url: `${backendDomin}/api/admin-edit-all-users-requests`, 
        method: 'put'
    },
    adminViewAllUsersRequests:{
        url: `${backendDomin}/api/admin-view-all-users-requests`, 
        method: 'get'
    },
    statusProduct : {
        url : `${backendDomin}/api/status-product`,
        method : 'post'
    },
    alternativeProduct : {
        url : `${backendDomin}/api/alternative-product`,
        method : 'post'
    },
    adminStatusProduct : {
        url : `${backendDomin}/api/admin-status-product`,
        method : 'post'
    },
    deleteProduct: {
        url: `${backendDomin}/api/deleteProduct`,
        method: 'post',
    },
    adminProductDetails: {
        url: `${backendDomin}/api/adminProductDetails`,
        method: 'post',
    },
    adminAlternativeProduct: {
        url: `${backendDomin}/api/adminAlternativeProduct`,
        method: 'post',
    },
    adminCategoryWiseProduct: {
        url: `${backendDomin}/api/adminCategoryWiseProduct`,
        method: 'post',
    },
    getUserByEmail: {
        url: `${backendDomin}/api/getUserByEmail`,
        method: 'post',
    },
    deleteFromCart: {
        url: `${backendDomin}/api/deleteFromCart`,
        method: 'post',
    },

    userMailOTPVerify: {
        url: `${backendDomin}/api/userMailOTPVerify`,
        method: 'post',
    },
    userMailSendVerification: {
        url: `${backendDomin}/api/userMailSendVerification`,
        method: 'post',
    },
    getSalesmenByType: {
        url: `${backendDomin}/api/getSalesmenByType`,
        method: 'post',
    },

    salesManGetUsers: {
        url: `${backendDomin}/api/salesManGetUsers`,
        method: 'post',
    },

    deptVerifyOTP: {
        url: `${backendDomin}/api/deptVerifyOTP`,
        method: 'post',
    },
    deptRequestOTP: {
        url: `${backendDomin}/api/deptRequestOTP`,
        method: 'post',
    },
    salesManViewMedicinePayment: {
        url: `${backendDomin}/api/salesManViewMedicinePayment`,
        method: 'post',
    },
    salesManViewCosmeticPayment: {
        url: `${backendDomin}/api/salesManViewCosmeticPayment`,
        method: 'post',
    },
    salesManViewMedicineOrders: {
        url: `${backendDomin}/api/salesManViewMedicineOrders`,
        method: 'post',
    },
    salesManViewCosmeticOrders: {
        url: `${backendDomin}/api/salesManViewCosmeticOrders`,
        method: 'post',
    },
    salesManViewMedicineOrder: {
        url: `${backendDomin}/api/salesManViewMedicineOrder`,
        method: 'get',
    },
    salesManViewCosmeticOrder: {
        url: `${backendDomin}/api/salesManViewCosmeticOrder`,
        method: 'get',
    },
    deptCosmeticUserView: {
        url: `${backendDomin}/api/deptCosmeticUserView`,
        method: 'post',
    },
    userViewOrderDetails: {
        url: `${backendDomin}/api/userViewOrderDetails`,
        method: 'get',
    },
    userEditOrderStatus: {
        url: `${backendDomin}/api/userEditOrderStatus`,
        method: 'PUT',
    },
    updateOrder: {
        url: `${backendDomin}/api/updateOrder`,
        method: 'post',
    },
    
    
    createRefundRequest: {
        url: `${backendDomin}/api/createRefundRequest`,
        method: 'post',
    },
    salesManCreateRefundRequest: {
        url: `${backendDomin}/api/salesManCreateRefundRequest`,
        method: 'post',
    },

    
    allRefundRequests: {
        url: `${backendDomin}/api/allRefundRequests`,
        method: 'post',
    },
    rejectRefundRequest: {
        url: `${backendDomin}/api/rejectRefundRequest`,
        method: 'post',
    },
    acceptRefundRequest: {
        url: `${backendDomin}/api/acceptRefundRequest`,
        method: 'post',
    },
    deleteOrders: {
        url: `${backendDomin}/api/deleteOrders`,
        method: 'post',
    },

    

    addUser : {
        url : `${backendDomin}/api/addUser`,
        method : 'post'
    },
    userRefundRequests : {
        url : `${backendDomin}/api/userRefundRequests`,
        method : 'post'
    },
    removeRefundRequest : {
        url : `${backendDomin}/api/removeRefundRequest`,
        method : 'post'
    },
    searchOrderCosmeticProduct : {
        url : `${backendDomin}/api/searchOrderCosmeticProduct`,
        method : 'post'
    },
    searchOrderProduct : {
        url : `${backendDomin}/api/searchOrderProduct`,
        method : 'post'
    },
    getPharmacies : {
        url : `${backendDomin}/api/getPharmacies`,
        method : 'post'
    },
    uploadAdvertisement : {
        url : `${backendDomin}/api/uploadAdvertisement`,
        method : 'post'
    },
    allAdvertisements : {
        url : `${backendDomin}/api/allAdvertisements`,
        method : 'get'
    },
    deleteAdvertisement : {
        url : `${backendDomin}/api/deleteAdvertisement`,
        method : 'post'
    },
    getBarMessage : {
        url : `${backendDomin}/api/getBarMessage`,
        method : 'get'
    },
    updateBarMessage : {
        url : `${backendDomin}/api/updateBarMessage`,
        method : 'post'
    },
    uploadNewBrand : {
        url : `${backendDomin}/api/uploadNewBrand`,
        method : 'post'
    },
    getBrands : {
        url : `${backendDomin}/api/getBrands`,
        method : 'post'
    },
    updateBrand : {
        url : `${backendDomin}/api/updateBrand`,
        method : 'post'
    },
    salesmanPaymentController : {
        url : `${backendDomin}/api/salesmanPaymentController`,
        method : 'post'
    },
    getSales : {
        url : `${backendDomin}/api/getSales`,
        method : 'post'
    },
    getBarMinimum : {
        url : `${backendDomin}/api/getBarMinimum`,
        method : 'get'
    },
    updateBarMinimum : {
        url : `${backendDomin}/api/updateBarMinimum`,
        method : 'post'
    },
    editManager: {
        url: `${backendDomin}/api/editManager`,
        method: 'post',
    },
    deleteBrand: {
        url: `${backendDomin}/api/deleteBrand`,
        method: 'post',
    },

    
    

}

export default SummaryApi